// @flow
import * as React from 'react';
import { withRouter } from 'speed-js-react';
import { createLocation } from 'history';

function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

type Props = {
    to: string | Object,
    replace: boolean,
    innerRef?: {current: null | React.ElementRef<React.ElementType>}
        | (React.ElementRef<React.ElementType>) => mixed | string,
    target?: string,
    onClick?: (SyntheticMouseEvent<HTMLElement>) => {},
    as?: string | typeof React.Component,
    children?: (props: Object) => React.Node,
    history: Object,
    location: Object,
}

@withRouter
class Link extends React.Component<Props> {
    static defaultProps = {
        target: undefined,
        onClick: undefined,
        innerRef: undefined,
        as: 'a',
        children: undefined,
        history: {},
        location: {},
    };

    handleClick = (event: SyntheticMouseEvent<HTMLElement>) => {
        const {
            onClick, target, replace, to, history,
        } = this.props;

        if (onClick) onClick(event);

        if (
            !event.defaultPrevented // onClick prevented default
            && event.button === 0 // ignore everything but left clicks
            && (!target || target === '_self') // let browser handle 'target=_blank' etc.
            && !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();

            const method = replace ? history.replace : history.push;

            method(to);
        }
    };

    render() {
        const {
            innerRef, replace, to, as: Component, children, history, location: _loc, ...rest
        } = this.props; // eslint-disable-line no-unused-vars

        const location = typeof to === 'string'
            ? createLocation(to, null, null, _loc)
            : to;
        const href = location ? history.createHref(location) : '';

        if (children) {
            return children({
                ...rest,
                onClick: this.handleClick,
                href,
                ref: innerRef,
            });
        }

        return (
            <Component
                {...rest}
                onClick={this.handleClick}
                href={href}
                // $FlowFixMe
                ref={innerRef}
            />
        );
    }
}

export default Link;
